import React from 'react';
import * as IoC from 'typescript-ioc';
import classnames from 'classnames';
import { isSameDay } from 'date-fns';
import { getFormattedTimezoneOffset, utcToZonedTime } from '../../../infrastructure/utils/date-fns-overrides.utils';
import { DateTimeFormatter } from '../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats } from '../../../infrastructure/date-formatter';

interface IMeetingDateTimeColumnProps {
    startDateTime: Date;
    endDateTime: Date;
    eventTimezone: string;
    isStartEndTimeRenderedInPreviousRow: boolean;
    mergeWithPreviousRowClass: string;
}

const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);

const MeetingDateTimeColumn: React.FC<IMeetingDateTimeColumnProps> = (props: IMeetingDateTimeColumnProps) => {
    const {
        startDateTime,
        endDateTime,
        eventTimezone,
        isStartEndTimeRenderedInPreviousRow,
        mergeWithPreviousRowClass,
    } = props;

    const startTime = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        dateTimeFormatter.getLocalTimeFormat()
    );
    const endTime = dateTimeFormatter.dateToFormattedString(
        endDateTime,
        dateTimeFormatter.getLocalTimeFormat()
    );

    const startTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        dateTimeFormatter.getLocalTimeFormat(),
        eventTimezone
    );

    const endTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(
        endDateTime,
        dateTimeFormatter.getLocalTimeFormat(),
        eventTimezone
    );

    const isEventTimezoneTimeDifferents = startTimeInEventTimezone !== startTime;

    const timeZoneOffset = getFormattedTimezoneOffset(startDateTime);

    const localDayString = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        DateFnsFormats.StringifiedFullDayMonthNumericDateYear,
    );

    return isStartEndTimeRenderedInPreviousRow ? <td data-testid='merged-with-row' className='schedule column-with-filters merge-with-previous-row'/> : (
        <td data-testid='meeting-date-row' className={classnames('schedule', 'column-with-filters', mergeWithPreviousRowClass)}>
            <div className='schedule meeting-list-item__header meeting-list-item__header--date-and-time'>
                {startTimeInEventTimezone} - {endTimeInEventTimezone}
            </div>
            { !isSameDay(startDateTime, utcToZonedTime(startDateTime, eventTimezone)) &&
                <div className='schedule
                            meeting-list-item__text
                            meeting-list-item__text--small
                            meeting-list-item__text--date-and-time'
                     data-testid='local-day'>
                    {localDayString}
                </div>
            }
            { isEventTimezoneTimeDifferents &&
                <div className='schedule meeting-list-item__text
                            meeting-list-item__text--small
                            meeting-list-item__text--date-and-time'
                     data-testid='local-time'>
                    {startTime} - {endTime} ({timeZoneOffset})
                </div>
            }
        </td>
    );
};

export default MeetingDateTimeColumn;
